export default __webpack_public_path__ + "assets/icons/contact-email.bf72fef9.svg";